// File: client/src/platform/composeMiddleware.js
//
// Compose several move-middleware "contributions" into one moveMiddleware object,
// so a variant (Chaos Chess) can stack independent, conflict-free mechanics.
//
// Composition rules (chosen to be safe and order-independent for independent toggles):
//   beforeMove:          ALL must allow; the first veto wins (returns its reason).
//   transformLegalMoves: chained left-to-right (each receives the previous output).
//   afterMove:           every contribution runs (each may mutate the board); the
//                        turn ends only if NONE requested it stay open (turnEnded
//                        === false from any contribution keeps it open).
//
// A "contribution" is a partial moveMiddleware ({ beforeMove?, transformLegalMoves?,
// afterMove? }). null/undefined contributions are ignored, so callers can pass a
// sparse list of enabled toggles.

export function composeMiddleware(contributions) {
  const list = (contributions || []).filter(Boolean);

  return {
    beforeMove(gameState, from, to) {
      for (const c of list) {
        if (typeof c.beforeMove === 'function') {
          const res = c.beforeMove(gameState, from, to);
          if (res && res.allow === false) return res; // first veto wins
        }
      }
      return { allow: true };
    },

    transformLegalMoves(gameState, from, engineMoves) {
      let moves = engineMoves;
      for (const c of list) {
        if (typeof c.transformLegalMoves === 'function') {
          moves = c.transformLegalMoves(gameState, from, moves) || moves;
        }
      }
      return moves;
    },

    afterMove(newState, from, to) {
      let keepOpen = false;
      for (const c of list) {
        if (typeof c.afterMove === 'function') {
          const res = c.afterMove(newState, from, to);
          if (res && res.turnEnded === false) keepOpen = true;
        }
      }
      return { turnEnded: !keepOpen };
    },
  };
}
